import { useEffect, useState } from 'react';
import styles from './hint-box.module.css';

interface HintBoxProps {
  hintText: string;
  delayMs?: number;
}

function HintBox({ hintText, delayMs = 300000 }: HintBoxProps) {
  const [showHint, setShowHint] = useState(false);
  const [progress, setProgress] = useState(100);
  const [hintUnlocked, setHintUnlocked] = useState(false);
  const [showTemporary, setShowTemporary] = useState(false);

  useEffect(() => {
    const startTime = Date.now();
    const interval = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(0, 100 - (elapsed / delayMs) * 100);
      setProgress(remaining);
      
      if (remaining === 0) {
        clearInterval(interval);
      }
    }, 100);

    const timer = setTimeout(() => {
      setHintUnlocked(true);
      setShowHint(true);
      
      // Göm efter 5 sekunder
      setTimeout(() => {
        setShowHint(false);
      }, 5000);
    }, delayMs);

    return () => {
      clearTimeout(timer);
      clearInterval(interval);
    };
  }, [delayMs]);

  const handleIconClick = () => {
    setShowTemporary(true);
    
    // Göm efter 10 sekunder
    setTimeout(() => {
      setShowTemporary(false);
    }, 10000);
  };

  // const handleProgressClick = () => {
  //     setHintUnlocked(true);
  //     setShowHint(true);
  //     setProgress(0);
      
  //     setTimeout(() => {
  //       setShowHint(false);
  //     }, 5000);
  // };

  return (
    <>
      {!hintUnlocked && (
        <div 
          className={styles.progressContainer}
          // onClick={handleProgressClick}
        >
          <div 
            className={styles.progressBar} 
            style={{ width: `${progress}%` }}
          />
        </div>
      )}
      {(showHint || showTemporary) && (
        <div className={styles.hintBox}>
          <div className={styles.hintIcon}>💡</div>
          <p className={styles.hintText}>{hintText}</p>
        </div>
      )}
      {hintUnlocked && !showHint && !showTemporary && (
        <div 
          className={styles.hintButton}
          onClick={handleIconClick}
        >
          💡
        </div>
      )}
    </>
  );
}

export default HintBox;
